export default {
  data () {
    return {
      modals: {},
      selectedItem: null,
    }
  },
  methods: {
    openModal (modal, item) {
      this.modals[modal] = true
      this.selectedItem = { ...item }
    },
    closeModal (modal) {
      this.modals[modal] = false
      this.selectedItem = null
    },
  },
}
